var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup9626(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.644,
    height: 28.905,
    viewBox: "0 0 31.644 28.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9626",
    "data-name": "Group 9626",
    transform: "translate(-191.292 -612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "demand",
    transform: "translate(191.292 612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9619",
    "data-name": "Group 9619",
    transform: "translate(11.483 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11374",
    "data-name": "Path 11374",
    d: "M271.146,103.3h-13.7a1.05,1.05,0,0,0-1.048,1.049v8.584a1.05,1.05,0,0,0,1.048,1.048h7.791l4.439,3.187V113.98h1.47a1.05,1.05,0,0,0,1.048-1.048v-8.584a1.051,1.051,0,0,0-1.048-1.048Z",
    transform: "translate(-252.034 -99.774)",
    fill: "#fad808",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11375",
    "data-name": "Path 11375",
    d: "M189.224,48.188h13.7a1.051,1.051,0,0,1,1.049,1.049v8.584a1.05,1.05,0,0,1-1.049,1.048h-7.791l-4.439,3.188V58.869h-1.47a1.051,1.051,0,0,1-1.049-1.048V49.237A1.051,1.051,0,0,1,189.224,48.188Z",
    transform: "translate(-188.175 -48.188)",
    fill: "#22c269",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9620",
    "data-name": "Group 9620",
    transform: "translate(0 9.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11376",
    "data-name": "Path 11376",
    d: "M23.986,350.711a7.691,7.691,0,0,0-15.343,0,.512.512,0,0,0,.511.548H23.475a.512.512,0,0,0,.511-.548Z",
    transform: "translate(-8.641 -334.615)",
    fill: "#62a4fb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11377",
    "data-name": "Path 11377",
    d: "M67.772,211.906a4.157,4.157,0,1,0-4.157-4.157A4.165,4.165,0,0,0,67.772,211.906Z",
    transform: "translate(-60.099 -203.592)",
    fill: "#ffd6bd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9621",
    "data-name": "Group 9621",
    transform: "translate(14.284 1.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11378",
    "data-name": "Path 11378",
    d: "M237.06,70.794l5.1,1.982V76.6l-5.1,1.982-5.1-1.982V72.776Z",
    transform: "translate(-231.963 -70.794)",
    fill: "#bd6428",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11379",
    "data-name": "Path 11379",
    d: "M311.656,70.794l5.1,1.982V76.6l-5.1,1.982Z",
    transform: "translate(-306.559 -70.794)",
    fill: "#a35623",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11380",
    "data-name": "Path 11380",
    d: "M237.06,70.794l5.1,1.982-5.1,1.982-5.1-1.982Z",
    transform: "translate(-231.963 -70.794)",
    fill: "#994f1f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11381",
    "data-name": "Path 11381",
    d: "M258.344,107.233l.844-.328,1.525.747-.647.252v1.606l-1.723-.645Z",
    transform: "translate(-256.657 -104.595)",
    fill: "#eff4f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11382",
    "data-name": "Path 11382",
    d: "M263.441,81.051l1.723.67-5.1,1.982-1.723-.67Z",
    transform: "translate(-256.657 -80.395)",
    fill: "#e2e3e3",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "new",
    transform: "translate(204.384 625.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11410",
    "data-name": "Path 11410",
    d: "M15.789,7.919,13.716,6.247l1.332-2.312L12.236,3.69,11.989.984,9.621,2.116,7.993,0,6.463,2.164,4,.885l-.148,2.8-2.763.148L2.122,6.493,0,7.771,2.171,9.395,1.085,11.706,3.8,12l.148,2.755,2.516-1.181,1.678,2.213,1.48-2.213,2.319,1.131.2-2.755,2.714-.049L13.864,9.64Z",
    fill: "#e04f5f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9623",
    "data-name": "Group 9623",
    transform: "translate(3.744 5.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11411",
    "data-name": "Path 11411",
    d: "M122.382,211.732l-.974-2.783.735-.257.935.818a8.623,8.623,0,0,1,.788.795l.012,0a10.853,10.853,0,0,1-.46-1.141l-.285-.814.578-.2.974,2.783-.661.231-.97-.865a11.057,11.057,0,0,1-.827-.813l-.01.008c.145.362.291.751.449,1.2l.294.838Z",
    transform: "translate(-121.408 -206.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11412",
    "data-name": "Path 11412",
    d: "M227.717,214.774c.112.253.411.287.7.185a1.882,1.882,0,0,0,.528-.278l.231.4a2.113,2.113,0,0,1-.687.38,1.027,1.027,0,0,1-1.438-.651,1.072,1.072,0,0,1,.643-1.434.949.949,0,0,1,1.253.692,1.626,1.626,0,0,1,.067.255Zm.589-.688a.386.386,0,0,0-.5-.284.436.436,0,0,0-.245.545Z",
    transform: "translate(-223.726 -211.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11413",
    "data-name": "Path 11413",
    d: "M285.279,171.211l.449.769c.115.2.235.4.348.625l.008,0c-.039-.246-.063-.5-.082-.712l-.076-.9.5-.174.484.734c.133.208.266.417.389.633l.008,0c-.051-.241-.09-.483-.125-.73l-.107-.862.616-.216.087,2.236-.59.207-.439-.644c-.119-.181-.22-.349-.347-.583l-.009,0a5.031,5.031,0,0,1,.088.673l.046.781-.59.207-1.292-1.814Z",
    transform: "translate(-279.606 -170.368)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9626);
export default __webpack_public_path__ + "static/media/Group 9626.f33c6ddac728c841345fe86ce63ceb0f.svg";
export { ForwardRef as ReactComponent };